import { createIcons, CircleX, AlertTriangle, Info } from "lucide";

class AppErrorState extends HTMLElement {
  connectedCallback() {
    const code = this.getAttribute("code") || "Error";
    const message = this.getAttribute("message") || "Ocorreu um erro inesperado.";

    let icon = "alert-triangle";
    let iconClass = "empty-state-icon";
    
    if (code === "404") {
      icon = "info";
    } else if (code === "403" || code === "401") {
      icon = "circle-x";
      iconClass = "empty-state-icon text-danger";
    }

    this.innerHTML = `
      <div class="error-state">
        <div class="${iconClass}">
          <i data-lucide="${icon}"></i>
        </div>
        <div class="empty-state-title">${code}</div>
        <div class="empty-state-desc">${message}</div>
      </div>
    `;

    createIcons({
      icons: { CircleX, AlertTriangle, Info },
      nameAttr: "data-lucide",
      root: this
    });
  }
}

if (!customElements.get("app-error-state")) {
  customElements.define("app-error-state", AppErrorState);
}
